import gift from '../../assets/drawer/gift.webp'

const BouncingGift = () => {
  return (
    <div className="relative w-[22px] h-[22px] left-[-7px] -top-2 animate-bounce">
      <img src={gift} className="w-full h-full" alt="Gift" />
    </div>
  )
}

export default BouncingGift
